import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, FeatureType, ValidationMessage, ValidationMessageType, TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';

export default class BasePeripheral extends BaseFeature {
    constructor() {
        super();
        this.singleInstance = false;
        this.featureType = FeatureType.PERIPHERAL;
        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                // dataType: TibboDataType.INTEGER,
                required: true,
                default: 'peripheral',
            },
            {
                id: 'BUILTIN',
                name: 'Built In',
                settingType: SettingType.BOOLEAN,
                readonly: true,
                default: '0',
            },
            {
                id: 'BUILTINID',
                name: 'Built In ID',
                settingType: SettingType.HIDDEN,
                readonly: true,
                default: '',
            },
        ];
        this.settings = this.settings.concat(settings);
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        for (let i = 0; i < this.settings.length; i += 1) {
            const setting = this.settings[i];
            if (setting.settingType === SettingType.PIN) {
                if (setting.required && setting.value === undefined) {
                    errors.push({ message: `${setting.id} (${setting.name}) not set for ${this.getName()}`, messageType: ValidationMessageType.ERROR });
                }
            }
        }
        return errors;
    }
}
